// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Success_mainContainer__15zSB","goToHomeButton":"Success_goToHomeButton__14oSs","mainColumn":"Success_mainColumn__2Pi23","title":"Success_title__2WuB6"};